import { create } from "zustand";
import { AxiosError } from "axios";
import { apiClient } from "@/api/client";
import useAuthStore from "@/store/authStore";

interface UserData {
  first_name: string;
  last_name: string;
  password: string;
  password_confirmation: string;
  number: string;
  country_code: string;
  address: string;
  date_of_birth: string;
  language: string;
  timezone: string;
  bio: string;
  token: string;
}

interface OnboardingState {
  userData: Partial<UserData>;
  sendUserData: (data: Partial<UserData>) => Promise<void>;
  validateToken: (token: string) => Promise<boolean>;
}

const useMediaUserOnboardingStore = create<OnboardingState>((set) => ({
  userData: {},

  sendUserData: async (data: UserData) => {
    try {
      const response = await apiClient.post(
        `/media-agency-invitations/accept/${data.token}`,
        data
      );
      useAuthStore
        .getState()
        .setAuth(
          response.data.user,
          response.data.token,
          null,
          null,
          null,
          null
        );
      set({ userData: response.data });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage = axiosError.response
        ? axiosError.response.data?.message || "Something went wrong"
        : "Something went wrong";
      throw new Error(errorMessage);
    }
  },

  validateToken: async (token) => {
    try {
      const res = await apiClient.get(
        `/global-media-agency-invitations/${token}`
      );
      const tokenResponse = res.data.data;
      return tokenResponse;
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      if (axiosError.status == 500) {
        const errorMessage = axiosError.response
          ? axiosError.response.data?.message || "Something went wrong"
          : "Something went wrong";
        throw new Error(errorMessage);
      }
      return false;
    }
  },
}));

export default useMediaUserOnboardingStore;
